<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="page-title-box">
          <div class="float-right">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);">BPD BALI</a>
              </li>
              <li class="breadcrumb-item active">Transaksi Tetap</li>
              <li class="breadcrumb-item active">
                {{
                  $route.name == "instanceTransactionFixedCreate"
                    ? "Create"
                    : "Edit"
                }}
              </li>
            </ol>
          </div>

          <h4 class="page-title">
            <router-link :to="{ name: 'instanceTransactionFixed' }">
              <i class="fas fa-arrow-left mr-2"></i>
            </router-link>
            Transaksi
          </h4>
        </div>
      </div>
    </div>

    <div class="card card-loader d-flex" v-if="loadingInitial">
      <div class="justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Loading</p>
      </div>
    </div>

    <form @submit.prevent="submitForm()" v-else>
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="pills-index-tab"
            data-toggle="pill"
            href="#pills-index"
            role="tab"
            aria-controls="pills-index"
            aria-selected="true"
            >Transaksi</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-retribution-tab"
            data-toggle="pill"
            href="#pills-retribution"
            role="tab"
            aria-controls="pills-retribution"
            aria-selected="false"
            >Wajib Retribusi</a
          >
        </li>
        <!-- <li class="nav-item">
                    <a class="nav-link" id="pills-forfeit-tab" data-toggle="pill" href="#pills-forfeit" role="tab" aria-controls="pills-forfeit" aria-selected="false">Denda</a>
                </li> -->
      </ul>

      <div class="tab-content" id="pills-tabContent">
        <!-- TRANSACITION -->
        <div
          class="tab-pane fade show active"
          id="pills-index"
          role="tabpanel"
          aria-labelledby="pills-index-tab"
        >
          <div class="card">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-6">
                  <div
                    class="form-group mb-0"
                    :class="{ 'is-invalid': $v.transactionForm.name.$error }"
                  >
                    <div class="form-group mb-0">
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                        >Nama</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="eg. Masukkan Nama"
                        v-model="transactionForm.name"
                        :disabled="loading"
                      />
                      <div
                        class="error"
                        v-if="!$v.transactionForm.name.required"
                      >
                        Nama wajib diisi
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label for="flexible" class="col-form-label text-left d-block"
                    >Transaksi dapat dirubah perbulannya</label
                  >
                  <div class="custom-control custom-switch switch-primary mt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="transactionForm.is_editable"
                      id="flexible"
                    />
                    <label class="custom-control-label" for="flexible"
                      >Ya, Transaksi ini dapat diubah</label
                    >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div
                    class="form-group"
                    :class="{
                      'is-invalid': $v.transactionForm.period_value.$error,
                    }"
                  >
                    <label
                      for="example-text-input"
                      class="col-form-label text-left d-block"
                      >Periode tagihan (dalam bulan)</label
                    >
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control"
                        v-model.trim="$v.transactionForm.period_value.$model"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">Bulan</span>
                      </div>
                    </div>
                    <div
                      class="error"
                      v-if="!$v.transactionForm.period_value.required"
                    >
                      Periode tagihan wajib diisi
                    </div>
                    <div
                      class="error"
                      v-if="!$v.transactionForm.period_value.minValue"
                    >
                      Periode tagihan minimal 1
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div
                    class="form-group"
                    :class="{
                      'is-invalid': $v.transactionForm.billing_date.$error,
                    }"
                  >
                    <label
                      for="example-text-input"
                      class="col-form-label text-left d-block"
                      >Periode Setiap Tanggal</label
                    >
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control"
                        v-model.trim="$v.transactionForm.billing_date.$model"
                      />
                    </div>
                    <div
                      class="error"
                      v-if="!$v.transactionForm.billing_date.required"
                    >
                      Periode tanggal wajib diisi
                    </div>
                    <div
                      class="error"
                      v-if="!$v.transactionForm.billing_date.minValue"
                    >
                      Periode tanggal minimal 1
                    </div>
                    <div
                      class="error"
                      v-if="!$v.transactionForm.billing_date.maxValue"
                    >
                      Periode tanggal maximal 31
                    </div>
                  </div>
                </div>
              </div>

              <!-- FORFEIT -->
              <div class="form-group mb-0">
                <div class="custom-control custom-switch switch-primary">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitchPrimary"
                    v-model="penaltyForm.is_penalty"
                  />
                  <label class="custom-control-label" for="customSwitchPrimary"
                    >Terdapat denda pada transaksi ini</label
                  >
                </div>
              </div>

              <div v-if="penaltyForm.is_penalty">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                        >Periode</label
                      >
                      <select
                        class="form-control"
                        v-model="penaltyForm.penalty_period"
                      >
                        <!-- <option value="DAILY">Harian</option>
                                                <option value="WEEKLY">Mingguan</option> -->
                        <option value="MONTHLY" selected>Bulanan</option>
                        <option value="YEARLY">Tahunan</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-lg-3">
                    <div
                      class="form-group"
                      :class="{
                        'is-invalid':
                          $v.penaltyForm.penalty_period_value.$error,
                      }"
                    >
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                        >Periode Penalti</label
                      >
                      <div class="input-group">
                        <input
                          type="number"
                          class="form-control"
                          v-model.trim="
                            $v.penaltyForm.penalty_period_value.$model
                          "
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">{{
                            penaltyPeriodConvert
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.penalty_period_value.required"
                      >
                        Periode penalti wajib diisi
                      </div>
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.penalty_period_value.minValue"
                      >
                        Periode penalti minimal adalah 1
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-3">
                    <div
                      class="form-group"
                      :class="{ 'is-invalid': $v.penaltyForm.due_date.$error }"
                    >
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                      >
                        Tanggal Penalti
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="$v.penaltyForm.due_date.$model"
                      />
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.due_date.required"
                      >
                        Tanggal penalti harus diisi
                      </div>
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.due_date.minValue"
                      >
                        Tanggal penalti minimal adalah tanggal 1
                      </div>
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.due_date.maxValue"
                      >
                        Tanggal penalti maksimal adalah tanggal 31
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="example-text-input" class="col-form-label text-left d-block">Simulasi Tanggal Penalti</label>
                                            <input type="text" class="form-control" :value="penaltyForm.due_date">
                                        </div>
                                    </div> -->
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                        >Tipe Penalti</label
                      >
                      <select
                        class="form-control"
                        v-model="penaltyForm.penalty_nominal_type"
                      >
                        <option value="FIXED">Harga Tetap</option>
                        <option value="PERCENTAGE">Persentase</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div
                      class="form-group mb-0"
                      :class="{
                        'is-invalid':
                          $v.penaltyForm.penalty_nominal_value.$error,
                      }"
                    >
                      <label
                        for="example-text-input"
                        class="col-form-label text-left d-block"
                        >Jumlah penalti ({{
                          penaltyForm.penalty_nominal_type == "FIXED"
                            ? "Rp."
                            : "%"
                        }})</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-currency="currencyMask"
                        v-model.trim="
                          $v.penaltyForm.penalty_nominal_value.$model
                        "
                      />
                      <div
                        class="error"
                        v-if="!$v.penaltyForm.penalty_nominal_value.required"
                      >
                        Jumlah penalti wajib diisi
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex">
            <button
              type="button"
              class="btn btn-primary waves-effect waves-light"
              style="margin-bottom: 20px; margin-left: auto"
              @click="addService()"
              :disabled="loading"
            >
              <i class="fas fa-plus mr-2"></i>
              <span>Tambah</span>
            </button>
          </div>

          <div class="card mb-0">
            <table class="table mb-0">
              <thead>
                <th>Aksi</th>
                <th>Kategori Retribusi</th>
                <th>Harga</th>
                <th>Jumlah</th>
                <th>Total</th>
              </thead>
              <tbody v-if="loaderService">
                <tr>
                  <td colspan="5" class="text-center">
                    <div class="justify-content-center">
                      <div
                        class="spinner-border"
                        style="width: 3rem; height: 3rem"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                      <p class="mt-2">Loading</p>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <!-- NOTE: NEED TO WORK WITH THIS VALIDATION -->
                <Field
                  v-for="(item, index) in transactionForm.objectRetribution"
                  :key="item.id"
                  :dataService="dataService"
                  :index="index"
                  :loading="false"
                  :dataObjectRetribution="transactionForm.objectRetribution"
                  :validationItter="validationItter"
                  @handleData="setData"
                  @handleRemove="removeService"
                >
                </Field>

                <!-- <tr>
                                    <td colspan="3">
                                        <label class="mt-1 d-block text-right">Metode Pembayaran </label>
                                    </td>
                                    <td colspan="2">
                                        <div class="form-group mb-0"
                                            :class="{ 'is-invalid': $v.transactionForm.payment_method.$error }">
                                            <select class="form-control select-2-form-payment" id="select-2-payment"
                                                :disabled="loading" v-model.trim="$v.transactionForm.payment_method.$model"
                                                v-select2>
                                                <option value="" selected disabled>--- Pilih Metode Pembayaran ----</option>
                                                <option value="BPD">BPD Bali</option>
                                                <option value="QRIS">QRIS</option>
                                                <option value="TUNAI">Tunai</option>
                                            </select>
                                            <div class="error" v-if="!$v.transactionForm.payment_method.required">Metode
                                                pembayaran wajib diisi</div>
                                        </div>
                                    </td>
                                </tr> -->

                <tr>
                  <td colspan="3">
                    <label class="mt-1 d-block text-right">Total </label>
                  </td>
                  <td colspan="2">
                    <div class="form-group mb-0">
                      <input
                        class="form-control text-right"
                        type="text"
                        v-currency="currencyMask"
                        :value="totalPrice"
                        readonly
                        :disabled="loading"
                      />

                      <input
                        class="form-control text-right"
                        type="text"
                        :value="totalPrice"
                        v-show="false"
                        readonly
                        :disabled="loading"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- WAJIB RETRIBUTION -->
        <div
          class="tab-pane fade"
          id="pills-retribution"
          role="tabpanel"
          aria-labelledby="pills-retribution-tab"
        >
          <div class="card mb-0">
            <div class="card-body">
              <div class="d-flex">
                <!-- v-if="retributionIds.length != dataCustomerTemporary.length" -->
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-light"
                  style="margin-bottom: 20px; margin-left: auto"
                  @click="addRetribution"
                  :disabled="loading"
                >
                  <i class="fas fa-plus mr-2"></i>
                  <span>Tambah</span>
                </button>
              </div>
              <div class="text-center my-30" v-if="loading_search">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <table class="table mb-0" v-else>
                <thead>
                  <th>Aksi</th>
                  <th>Wajib Retribusi</th>
                </thead>
                <tbody>
                  <tr v-if="retributionIds.length <= 0">
                    <td colspan="2" class="text-center">
                      Tidak ada data wajib retribusi
                    </td>
                  </tr>
                  <tr v-for="(item, index) in retributionIds" :key="item">
                    <td style="width: 5%">
                      <button
                        type="button"
                        style="margin-top: 8px"
                        :disabled="retributionIds.length <= 1"
                        class="btn waves-effect waves-light mb-2"
                        :class="classButton"
                        @click="removeRetribution(index, item)"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                    <td>
                      <div class="form-group mb-0">
                        {{ item.name }}
                        <!-- {{dataCustomerTemporary.filter(item => item.id == retributionIds[index])[0].name}} -->
                        <!-- <select class="form-control select-2-form" :disabled="loading"
                                                    v-model="retributionIds[index]" v-select2>
                                                    <option value="" selected disabled>--- Pilih Wajib Retribusi ----</option>
                                                    <option v-if="retributionIds[index] != ''" :value="retributionIds[index]">{{dataCustomerTemporary.filter(item => item.id == retributionIds[index])[0].name}}</option>
                                                    <option :value="item.id" :data-name="item.name" v-for="item in dataCustomer"
                                                        :key="item.id">
                                                        {{item.name}}</option>
                                                </select> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- FORFEIT -->
        <!-- <div class="tab-pane fade" id="pills-forfeit" role="tabpanel" aria-labelledby="pills-forfeit-tab">
                    <div class="card mb-0">
                        <div class="card-body">

                        </div>
                    </div>
                </div> -->
      </div>

      <button
        class="btn btn-success waves-effect waves-light mb-5"
        style="margin-top: 20px"
        :disabled="loading"
      >
        Simpan Transaksi
        <div
          class="spinner-border text-light ml-2"
          role="status"
          v-if="loading"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </button>
    </form>

    <div
      class="modal fade"
      id="modalListCustomer"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Tambah Wajib Retribusi
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0px">
            <div style="padding: 10px">
              <input
                type="text"
                name=""
                id="search-customer"
                class="form-control mb-2"
                placeholder="Cari ..."
                v-model="searchQuery"
                @input="onSearch"
              />
            </div>
            <div style="max-height: 70vh; overflow-y: auto">
              <div
                v-for="item in dataCustomer"
                :key="item.id"
                style="padding: 10px; border-bottom: 1px solid #ddd"
                class="d-flex align-items-center item-customer"
              >
                {{ item.name }}

                <button
                  class="btn btn-primary"
                  @click="addCustomer(item)"
                  style="margin-left: auto"
                >
                  Pilih
                </button>
              </div>
            </div>

            <div class="float-right">
              <paginate
                v-model="paging.currentPage"
                :page-count="paging.rows"
                :page-range="3"
                :margin-pages="2"
                :click-handler="paginate"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :container-class="'pagination mb-3 mr-3 mt-3'"
                :page-link-class="'page-link'"
                :page-class="'page-item'"
                align="right"
              >
              </paginate>
            </div>
          </div>
          <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-primary">Tambah</button>
                </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
import Field from "./field";
import {
  required,
  integer,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { debounce } from "debounce";

export default {
  data() {
    return {
      loadingInitial: true,
      loading_search: false,
      loaderService: false,
      loading: false,
      validationItter: { error: false, message: "", index: 0 },
      validationItterCustomer: { error: false, message: "", index: 0 },
      searchQuery: "",
      deleted_retributionIds: [],
      deleted_objectRetributionIds: [],
      // FORM TRANSACTION
      transactionForm: {
        name: "",
        period_value: 1,
        billing_date: 1,
        is_editable: false,
        is_billing: false,
        objectRetribution: [
          {
            id: null,
            price: 0,
            amount: 1,
            unit: 0,
            unit_type: "",
            total: 0,
          },
        ],
        payment_method: "BPD",
      },
      // RETRIBUTION ID (CUSTOMER)
      retributionIds: [],
      // PENALTY FORM
      penaltyForm: {
        is_penalty: 0,
        penalty_period: "MONTHLY",
        penalty_period_value: 1,
        due_date: 1,
        penalty_nominal_type: "FIXED",
        penalty_nominal_value: 0,
      },

      paging: {
        rows: 0,
        currentPage: 1,
        perPage: 10,
        total: 0,
        to: 0,
      },

      // MASTER DATA
      dataCustomer: [],
      dataService: [],
    };
  },
  validations() {
    if (!this.penaltyForm.is_penalty) {
      return {
        transactionForm: {
          name: { required },
          period_value: { required, minValue: minValue(1) },
          billing_date: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(31),
          },
          // payment_method: { required },
        },
      };
    } else {
      return {
        transactionForm: {
          name: { required },
          period_value: { required, minValue: minValue(1) },
          billing_date: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(31),
          },
          // payment_method: { required },
        },
        penaltyForm: {
          penalty_period_value: { required, minValue: minValue(1) },
          penalty_nominal_value: { required },
          due_date: { required, minValue: minValue(1), maxValue: maxValue(31) },
        },
      };
    }
  },
  computed: {
    // COUNT TOTAL PRICE
    totalPrice() {
      return this.transactionForm.objectRetribution.reduce(
        (a, { total }) => a + total,
        0
      );
    },
    // CONVERT PENALTY PERIOD NAME
    penaltyPeriodConvert() {
      const period = this.penaltyForm.penalty_period;
      if (period == "MONTHLY") {
        return "Bulanan";
      } else {
        return "Tahunan";
      }
    },
    // CLASS BUTTON FOR THE CUSTOMER
    classButton() {
      return this.retributionIds.length > 1 ? "btn-danger" : "btn-info";
    },
    // SEARCH QUERY
    // resultQuery(){
    //     const self = this
    //     if(this.searchQuery || this.searchQuery != ''){
    //         return this.dataCustomer.filter(function(cust){return cust.name.toLowerCase().indexOf(self.searchQuery.toLowerCase())>=0;});

    //     }else{
    //         return this.dataCustomer;
    //     }
    // }
  },
  watch: {
    // retributionIds: {
    //     handler(){
    //         this.dataCustomer = this.dataCustomerTemporary.filter(item => !this.retributionIds.includes(item.id))
    //         setTimeout(() => {
    //             $('.select-2-form').select2();
    //         }, 10);
    //     }
    // }
  },
  components: {
    Field,
  },
  methods: {
    // SET DATA TRANSACTION IN CHILDREN TO PARENT (THIS COMPONENT)
    setData(val) {
      const index = val.index;
      this.$set(this.transactionForm.objectRetribution, index, {
        id: val.id,
        price: parseInt(val.price),
        amount: parseInt(val.amount),
        total: parseInt(val.total),
        unit: parseInt(val.unit),
        unit_type: parseInt(val.unit_type),
        total: parseInt(val.total),
      });
    },
    paginate(page) {
      this.loadInitialData(page);
    },
    onSearch() {
      this.searchHeader(this);
    },
    searchHeader: debounce(async (vm) => {
      await vm.loadInitialData(1);
    }, 1500),
    // LOAD INITIAL DATA THAT NEEDED BEFORE CREATE FORM
    async loadInitialData(page) {
      this.loading_search = true;
      const customer = this.$http.get(`${this.API_URL}customer`, {
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token_instance")}`,
        },
        params: {
          page: page,
          name: this.searchQuery,
        },
      });
      const service = this.$http.get(`${this.API_URL}service`, {
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token_instance")}`,
        },
      });

      Promise.all([customer, service]).then(
        ([responseCustomer, responseService]) => {
          this.dataCustomer = responseCustomer.data.data.data;

          this.paging.rows = responseCustomer.data.data.last_page;
          this.paging.currentPage = responseCustomer.data.data.current_page;
          this.paging.perPage = responseCustomer.data.data.per_page;
          this.paging.total = responseCustomer.data.data.total;
          this.paging.to = responseCustomer.data.data.to;

          // this.dataCustomerTemporary = responseCustomer.data.data.data

          this.dataService = responseService.data.data;
          setTimeout(() => {
            $(".select-2-form").select2();
            $(".select-2-form-payment").select2();
            $(".select-2-custom-form").select2();
          }, 100);

          this.loading_search = false;
        }
      );
    },
    // ADD NEW SERVICE
    addService() {
      this.validationItter = { error: false, message: "", index: 0 };
      this.transactionForm.objectRetribution.push({
        id: null,
        price: 0,
        amount: 1,
        unit: 1,
        unit_type: null,
        total: 0,
      });
      setTimeout(() => {
        $(".select-2-custom-form").select2();
      }, 50);
    },
    // REMOVE SERVICE BASED ON INDEX
    removeService(state) {
      Swal.fire({
        title: "Apakah anda yakin untuk menghapus?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Hapus!",
      }).then((result) => {
        if (result.value) {
          console.log(state);
          if (state.id) {
            this.deleted_objectRetributionIds.push(state.id);
          }
          this.$delete(this.transactionForm.objectRetribution, state.index);
          this.loaderService = true;
          setTimeout(() => {
            this.loaderService = false;
          }, 100);
        }
      });
    },
    addRetribution() {
      $("#modalListCustomer").modal("show");
    },
    addCustomer(value) {
      if (
        this.retributionIds.filter((item) => item.id == value.id).length >= 1
      ) {
        this.sAlert("error", "Wajib Retribusi Sudah Ditambahkan Sebelumnya");
        return;
      }
      this.retributionIds.push(value);
      // if(this.retributionIds.length >= this.dataCustomerTemporary.length){
      //     $('#modalListCustomer').modal('hide')
      // }
    },
    filterCustomer() {
      var input = document.getElementById("search-customer");
      var filter = input.value.toLowerCase();
      console.log(filter);
      var nodes = document.getElementsByClassName("item-customer");

      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].innerText.toLowerCase().includes(filter)) {
          nodes[i].style.display = "block";
        } else {
          nodes[i].style.display = "none";
        }
      }
    },
    removeRetribution(index, id) {
      Swal.fire({
        title: "Apakah anda yakin untuk menghapus?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Hapus!",
      }).then((result) => {
        if (result.value) {
          console.log(id);
          if (id) {
            this.deleted_retributionIds.push(id);
          }
          this.retributionIds.splice(index, 1);
        }
      });
    },
    // SUBMIT FORM
    submitForm() {
      // CHECK VALIDATION
      if (this.$v.$invalid) {
        $('.nav-item a[href="#pills-index"]').tab("show");
        this.$v.$touch();
        this.sAlert("error", "Harap isi semua form dengan benar!");
        return;
      }

      if (this.retributionIds.length <= 0) {
        this.sAlert("error", "Pilih minimal satu wajib retribusi");
        $('.nav-item a[href="#pills-retribution"]').tab("show");
        return;
      }

      // CHECK VALIDATION ON SERVICES
      this.validationItter = { error: false, message: "", index: 0 };
      for (const [
        index,
        element,
      ] of this.transactionForm.objectRetribution.entries()) {
        if (element.id == "") {
          this.validationItter.error = true;
          this.validationItter.message = "Kategori Retribusi wajib dipilih";
          this.validationItter.index = index;
          break;
        } else if (element.amount <= 0 || element.amount == "") {
          this.validationItter.error = true;
          this.validationItter.message =
            "Jumlah wajib diisi atau tidak boleh kurang dari 0";
          this.validationItter.index = index;
          break;
        }
      }

      // CHECK VALIDATION ON CUSTOMER
      this.validationItterCustomer = { error: false, message: "", index: 0 };
      for (const [index, element] of this.retributionIds.entries()) {
        if (element == "") {
          this.validationItterCustomer.error = true;
          this.validationItterCustomer.message = "Customer wajib dipilih";
          this.validationItterCustomer.index = index;
          break;
        }
      }

      // CHECK VALIDATION
      if (this.validationItterCustomer.error) {
        $('.nav-item a[href="#pills-retribution"]').tab("show");
        this.sAlert("error", this.validationItterCustomer.message);
        return;
      } else {
        this.validationItterCustomer.error = false;
      }

      this.loading = true;

      let axiosMethod, alertSuccess, storedData;
      const defaultData = {
        name: this.transactionForm.name,
        period_value: this.transactionForm.period_value,
        billing_date: this.transactionForm.billing_date,
        is_editable: this.transactionForm.is_editable,
        is_billing: this.transactionForm.is_billing,
        objectRetribution: this.transactionForm.objectRetribution.map(
          (item) => {
            return {
              id: item.id,
              price: item.price,
              amount: this.reInteger(item.amount),
              unit: this.reInteger(item.unit),
              unit_type: this.reInteger(item.unit_type),
              total: this.reInteger(item.total),
            };
          }
        ),

        payment_method: this.transactionForm.payment_method,
        total: this.reInteger(this.totalPrice),
        retributionIds: this.retributionIds.map((item) => item.id),

        is_penalty: this.penaltyForm.is_penalty,
        penalty_period: this.penaltyForm.penalty_period,
        penalty_period_value: this.penaltyForm.penalty_period_value,
        due_date: this.penaltyForm.due_date,
        penalty_nominal_type: this.penaltyForm.penalty_nominal_type,
        penalty_nominal_value: this.reInteger(
          this.penaltyForm.penalty_nominal_value
        ),
      };

      if (this.$route.name == "instanceTransactionFixedCreate") {
        axiosMethod = {
          method: "POST",
          url: `${this.API_URL}billing/store`,
        };
        // SET STORED DATA
        storedData = {
          ...defaultData,
        };
        alertSuccess = "Berhasil membuat transaksi baru!";
      } else {
        axiosMethod = {
          method: "PUT",
          url: `${this.API_URL}billing/update/${this.$route.params.id}`,
        };
        // SET STORED DATA
        storedData = {
          ...defaultData,
          deleted_retributionIds: this.deleted_retributionIds,
          deleted_objectRetributionIds: this.deleted_objectRetributionIds,
        };
        alertSuccess = "Berhasil mengupdate transaksi!";
      }

      // STORE TRANSACTION
      this.$http({
        ...axiosMethod,
        data: storedData,
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token_instance")}`,
        },
      })
        .then((response) => {
          const result = response.data;

          if (result.success) {
            this.sAlert("success", "Berhasil membuat transaksi baru!");
            this.$router.push({ name: "instanceTransactionFixed" });
          } else {
            this.sAlert("error", result.message);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.sAlert("error", "Error, Terjadi Kesalahan!");
        });
    },
  },
  mounted() {
    if (!this.$store.state.userData.company.is_billing == 1) {
      this.$router.push({ name: "instanceDashboard" });
    }

    $(".tooltip").tooltip();

    this.loadingInitial = true;

    this.loadInitialData();

    this.loadingInitial = false;

    if (this.$route.name == "instanceTransactionFixedEdit") {
      this.loadingInitial = true;

      this.$http
        .get(`${this.API_URL}billing/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("token_instance")}`,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.transactionForm = {
              name: result.data.name,
              period_value: result.data.period_value,
              is_editable: result.data.is_editable,
              billing_date: result.data.billing_date,
              objectRetribution: result.data.detail.map((item) => {
                return {
                  id: item.service_id,
                  price: item.price,
                  amount: item.qty,
                  total: item.total,
                };
              }),
              payment_method: result.data.payment_method,
            };

            this.retributionIds = result.data.customers;

            this.penaltyForm.is_penalty = result.data.is_penalty;
            if (result.data.is_penalty) {
              this.penaltyForm = {
                is_penalty: result.data.is_penalty,
                penalty_period: result.data.penalty_period,
                penalty_period_value: result.data.penalty_period_value,
                due_date: moment(result.data.billing_due_date).format("D"),
                penalty_nominal_type: result.data.penalty_nominal_type,
                penalty_nominal_value: result.data.penalty_nominal_value,
              };
            }
          } else {
            this.sAlert("error", result.message);
          }
          this.loadingInitial = false;
        })
        .catch((error) => {
          this.loadingInitial = false;
          this.sAlert("error", "Error, Terjadi Kesalahan!");
        });
    }
  },
};
</script>

<style>
</style>